import { collection, getDocs } from 'firebase/firestore';

import { db } from '../firebase';

export const fetchMunicipalitiesByDistrict = async (
  region: string, 
  province: string, 
  district: string
): Promise<string[]> => {
  const municipalitiesRef = collection(
    db, 
    `tabulationsV2/SURIGAO DEL NORTE_DISTRICT 1/regions/${region}/provinces/${province}/districts/${district}/cities`
  );
  const snapshot = await getDocs(municipalitiesRef);
  return snapshot.docs.map(doc => doc.id);
};

export const fetchBarangaysByMunicipality = async (
  region: string, 
  province: string, 
  district: string, 
  municipality: string
): Promise<string[]> => {
  const barangaysRef = collection(
    db, 
    `tabulationsV2/SURIGAO DEL NORTE_DISTRICT 1/regions/${region}/provinces/${province}/districts/${district}/cities/${municipality}/barangays`
  );
  const snapshot = await getDocs(barangaysRef);
  return snapshot.docs.map(doc => doc.id);
};

export const fetchPrecinctsByBarangay = async (
  region: string, 
  province: string, 
  district: string, 
  municipality: string, 
  barangay: string
): Promise<string[]> => {
  const precinctRef = collection(
    db, 
    `tabulationsV2/SURIGAO DEL NORTE_DISTRICT 1/regions/${region}/provinces/${province}/districts/${district}/cities/${municipality}/barangays/${barangay}/precincts`
  );
  const snapshot = await getDocs(precinctRef);
  return snapshot.docs.map(doc => doc.id);
};

export const constructPollResponseCollectionPath = (
  region: string, 
  province: string, 
  district: string, 
  municipality: string, 
  barangay: string, 
  precinct?: string
): string => {
  const basePath = `tabulationsV2/SURIGAO DEL NORTE_DISTRICT 1/regions/${region}/provinces/${province}/districts/${district}/cities/${municipality}/barangays/${barangay}/precincts`;
  return precinct ? `${basePath}/${precinct}/voters` : basePath;
};
